import React from "react";

import useNavigationCollapse from "../../../../hooks/useNavigationCollapse";
import { NavigationLinkProps } from "./types";
import { NavIcon, StyledLabel, StyledNavLink, StyledNavLinkRow, StyledNavSubLink } from "./styles";

/** A navigation entry that routes somewhere. Sub-items are styled as the nested variant. */
export const NavigationLink = ({ label, to, icon, exact, isSubItem }: NavigationLinkProps) => {
  const { isCollapsed } = useNavigationCollapse();
  const Wrap = isSubItem ? StyledNavSubLink : StyledNavLink;

  return (
    <Wrap to={to as string} exact={exact} title={isCollapsed ? label : undefined}>
      <StyledNavLinkRow $isSubItem={!!isSubItem}>
        {icon && <NavIcon className="nav-icon">{icon}</NavIcon>}
        <StyledLabel $isCollapsed={isCollapsed}>{label}</StyledLabel>
      </StyledNavLinkRow>
    </Wrap>
  );
};

export default NavigationLink;
